import { george, helpers, observer, pr, React, RouteComponentProps, theme, ui } from "aaa";
import { AliasStore } from "components/alias/AliasStore";
import * as moment from "moment";
import { themeColors } from "muiTheme";
import { FormattedHTMLMessage } from "react-intl";
import { useRouteMatch } from "react-router";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import profileStore from "stores/ProfileStore";
import { pushRoute } from "stores/RouterFunctions";
import toastSore from "stores/ToastStore";
import { amountToCurrencyString, amountToNumber } from "types/amount";
import { ISIdDevice } from "types/ebvSecapp";
import { safeWindowOpen } from "util/helpers";
import { observable } from "../../../node_modules/mobx";
import { SIdentitySettingsDeleteConfirmationDialog } from "./SidentitySettingsDeleteConfirmationDialog";
import { SIdentitySettingsStore } from "./SIdentitySettingsStore";

type IProps = RouteComponentProps<{}> & {
    store: SIdentitySettingsStore
};

export const SectionHeader = (props: { children: any }) => (
    <h1 className="theme-paragraph-color" style={{ marginLeft: 16, marginTop: 16, fontSize: 12 }}>{props.children}</h1>
);

export const SigningMethodBanner = ({ children }: { children: React.ReactNode }) => (
    <div
        style={{
            alignItems: "center",
            textAlign: "center",
            padding: "12px 16px",
            backgroundColor: ui.isDarkMode ? themeColors.d_blue_100 : themeColors.blue_300
        }}
    >
        <pr.P_14_CONTENT style={{ color: "white" }}>
            {children}
        </pr.P_14_CONTENT>
    </div>
);

const SettingsButtonIcon = (props: {
    src: any;
    onClick?: () => void;
    "aria-label"?: string;
}) => (
        <img
            role={props.onClick ? "button" : ""}
            tabIndex={props.onClick ? 0 : undefined}
            onClick={props.onClick}
            src={props.src}
            style={{ marginLeft: 16, marginRight: 16, cursor: props.onClick ? "pointer" : "auto" }}
            aria-label={props["aria-label"]}
            onKeyUp={(e) => {
                if (props.onClick && (e.keyCode === 13 || e.keyCode === 32)) {
                    props.onClick();
                }
            }}
        />
    );

const SettingsButton = ({
    icon,
    border,
    borderRadius,
    onClick,
    children,
}: {
    icon: React.ReactNode;
    border: "top" | "bottom" | "both" | "none",
    borderRadius: "top" | "bottom" | "both" | "none",
    onClick?: () => void;
    children: any,
}) => (
        <div
            role={onClick ? "button" : ""}
            tabIndex={onClick ? 0 : undefined}
            className="theme-sidentity-settings-button-colors"
            style={{
                height: 64,
                display: "flex",
                alignItems: "center",
                cursor: onClick ? "pointer" : "auto",
                borderTopLeftRadius: borderRadius === "top" || borderRadius === "both" ? 10 : undefined,
                borderTopRightRadius: borderRadius === "top" || borderRadius === "both" ? 10 : undefined,
                borderBottomLeftRadius: borderRadius === "bottom" || borderRadius === "both" ? 10 : undefined,
                borderBottomRightRadius: borderRadius === "bottom" || borderRadius === "both" ? 10 : undefined,
            }}
            onClick={onClick}
            onKeyUp={(e) => {
                if (onClick && (e.keyCode === 13 || e.keyCode === 32)) {
                    onClick();
                }
            }}
        >
            {icon}
            <div
                style={{
                    display: "flex",
                    flexGrow: 1,
                    alignItems: "center",
                    height: "100%",
                    borderBottomWidth: 1,
                    borderBottomStyle: (border === "bottom" || border === "both") ? "solid" : "none",
                    borderTopWidth: 1,
                    borderTopStyle: (border === "top" || border === "both") ? "solid" : "none",
                    borderColor: ui.isDarkMode ? themeColors.d_grey_100 : themeColors.grey_200,
                }}
            >
                {children}
            </div>
        </div>
    );

// also used in alias and gidSettings feature - check back when changing
export const MyLoginData = observer(({ store, hideTitle }: { store: AliasStore, hideTitle?: boolean }) => {
    const match = useRouteMatch();

    return (
        <>
            {!hideTitle && (
                <SectionHeader>{ui.__("sidentitySettings.loginData")}</SectionHeader>
            )}
            <SettingsButton
                border="bottom"
                borderRadius="top"
                onClick={() => {
                    if (profileStore.profile) {
                        helpers.copyTextToClipboard(profileStore.profile?.userNumber.toString() ?? "");
                        toastSore.addMessage(ui.__("sidentitySettings.usernumberCopied"));
                    }
                }}
                icon={<pr.IconUser style={{ color: "#135EE2", flexShrink: 0, marginLeft: 16, marginRight: 16, }} />}
            >
                <div style={{ flex: 1 }}>
                    <pr.P_16_TITLE style={{ color: ui.isDarkMode ? "white" : "#0A285C", fontWeight: 500 }}>
                        {ui.__("common.usernumber")}
                    </pr.P_16_TITLE>
                    <pr.P_14_CONTENT style={{ flex: 1 }}>{profileStore.profile?.userNumber}</pr.P_14_CONTENT>
                </div>
                <pr.IconCopy2 style={{ color: "#135EE2", marginRight: 16 }} />
            </SettingsButton>
            {!store.currentUsername && (
                <SettingsButton
                    border="none"
                    borderRadius="bottom"
                    onClick={() => {
                        pushRoute(`${match.path}/username`);
                    }}
                    icon={<SettingsButtonIcon src={require("assets/plus.svg")} />}
                >
                    <pr.P_16_TITLE style={{ flex: 1, color: ui.isDarkMode ? "white" : "#0A285C", fontWeight: 500 }}>{ui.__("sidentitySettings.addUsername")}</pr.P_16_TITLE>
                    <div
                        style={{
                            boxSizing: "border-box",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: 20,
                            borderRadius: 10,
                            backgroundColor: theme.themeColors.ui_blue,
                            color: "white",
                            padding: "2px 8px",
                            fontSize: 12,
                            fontWeight: 600,
                            lineHeight: "16px"
                        }}
                    >
                        {ui.__("common.new")}
                    </div>
                    <pr.IconChevronRight style={{ color: "#A7B6C7", marginRight: 16 }} />
                </SettingsButton>
            )}
            {!!store.currentUsername && (
                <SettingsButton
                    border="none"
                    borderRadius="bottom"
                    onClick={() => {
                        pushRoute(`${match.path}/username`);
                    }}
                    icon={<pr.IconUser style={{ color: "#135EE2", flexShrink: 0, marginLeft: 16, marginRight: 16, }} />}
                >
                    <div style={{ flex: 1 }}>
                        <pr.P_16_TITLE style={{ color: ui.isDarkMode ? "white" : "#0A285C", fontWeight: 500 }}>
                            {ui.__("common.username")}
                        </pr.P_16_TITLE>
                        <pr.P_14_CONTENT style={{ flex: 1 }}>{profileStore.profile?.alias}</pr.P_14_CONTENT>
                    </div>
                    <pr.IconChevronRight style={{ color: "#A7B6C7", marginRight: 16 }} />
                </SettingsButton>
            )}
        </>
    );
});

const MyDevices = observer((props: { store: SIdentitySettingsStore, onDeleteDevice: (device: ISIdDevice) => void }) => {
    // debug.log("devices in store", props.store.devices!);
    const devices = props.store.devices && props.store.devices.map((device: ISIdDevice, index: number) => {
        const isPhone = device.clientType === "iOS" || device.clientType === "Android" || device.clientType === "WindowsPhone";
        const icon = isPhone ? require("assets/phone.svg") : require("assets/computer.svg");

        let borderRadius: React.ComponentProps<typeof SettingsButton>["borderRadius"] = "none";

        if (index === 0 || (props.store.devices ?? []).length === 1) {
            borderRadius = "top";
        }

        return (
            <SettingsButton
                key={device.id}
                border={index > 0 ? "top" : "none"}
                borderRadius={borderRadius}
                icon={<SettingsButtonIcon src={icon} />}
            >
                <div style={{ flex: 1 }}>
                    <pr.P_14_CONTENT style={{ color: theme.customColors.georgeLightGrey }}>
                        {`${ui.__("sidentitySettings.activationDate")} ${moment(device.activationDate.substr(0, device.activationDate.length - 5)).format("DD.MM.YYYY")}`}
                    </pr.P_14_CONTENT>
                    <pr.P_16_TITLE style={{ color: ui.isDarkMode ? "white" : "#0A285C", fontWeight: 500 }}>{device.alias || device.clientDevice}</pr.P_16_TITLE>
                    {device.alias && <pr.P_14_CONTENT>{device.clientDevice}</pr.P_14_CONTENT>}
                </div>
                {props.store.devices && props.store.devices.length > 1 &&
                    <SettingsButtonIcon
                        src={require("assets/bin.svg")}
                        onClick={() => props.onDeleteDevice(device)}
                        aria-label={ui.__("sidentitySettings.deleteDevice.confirm.title")}
                    />
                }
            </SettingsButton>
        );
    });

    return (
        <>
            <SectionHeader>{ui.__("sidentitySettings.activatedDevices")}</SectionHeader>
            {devices}
            <SettingsButton
                border={devices && devices.length > 0 ? "top" : "none"}
                borderRadius={devices && devices.length > 0 ? "bottom" : "both"}
                onClick={() => {
                    if (props.store.status?.secAppVariant === "DUAL") {
                        pushRoute("/sidentitysettings/add-device-category");
                    } else if (props.store.status?.secAppVariant === "DESKTOP") {
                        pushRoute("/sidentitysettings/add-desktop-device-info");
                    } else if (props.store.status?.secAppVariant === "APP") {
                        pushRoute("/sidentitysettings/add-device-summary");
                    }
                }}
                icon={<SettingsButtonIcon src={require("assets/plus.svg")} />}
            >
                <pr.P_16_TITLE style={{ flex: 1, color: ui.isDarkMode ? "white" : "#0A285C", fontWeight: 500 }}>{ui.__("sidentitySettings.addDevice")}</pr.P_16_TITLE>
                <pr.IconChevronRight style={{ color: "#A7B6C7", marginRight: 16 }} />
            </SettingsButton>
        </>
    );
});

// also used in gidSettings feature - check back when changing
export const Settings = observer(({ limit, limitManagementRoute }: { limit: string, limitManagementRoute: string }) => (
    <>
        <SectionHeader>{ui.__("sidentitySettings.settings")}</SectionHeader>
        <SettingsButton
            border="none"
            borderRadius="both"
            onClick={() => pushRoute(limitManagementRoute)}
            icon={<SettingsButtonIcon src={require("assets/arrows.svg")} />}
        >
            <div style={{ flex: 1 }}>
                <pr.P_16_TITLE style={{ color: ui.isDarkMode ? "white" : "#0A285C", fontWeight: 500 }}>{ui.__("sidentitySettings.dailyLimit")}</pr.P_16_TITLE>
                <pr.P_14_CONTENT>{limit}</pr.P_14_CONTENT>
            </div>

            <pr.IconChevronRight style={{ color: "#A7B6C7", marginRight: 16 }} />
        </SettingsButton>
    </>
));

const Onboarding = observer(({ store, showCardTanInfo }: { store: SIdentitySettingsStore, showCardTanInfo?: boolean }) => (
    <>
        <SectionHeader>{ui.__("sidentitySettings.signingMethod")}</SectionHeader>
        {showCardTanInfo && (
            <SigningMethodBanner>
                <FormattedHTMLMessage id="sidentitySettings.signingMethod.cardTan" />
            </SigningMethodBanner>
        )}
    </>
));

const GeorgeIdBanner = ({ style }: { style?: React.CSSProperties }) => {
    const handleClick = () => {
        if (externalInterfaceStore.isGeorgeApp) {
            safeWindowOpen("georgeapp://gid_migration");
        } else {
            pushRoute("/sidentitysettings/activate-george-id");
        }
    };

    return (
        <div
            style={{
                display: "flex",
                gap: 16,
                borderRadius: 8,
                padding: 12,
                cursor: "pointer",
                backgroundColor: themeColors.blue_300,
                ...style
            }}
            role="button"
            onClick={handleClick}
        >
            <img src={require("assets/georgeIdBannerLogo.svg")} />
            <div>
                <pr.P_16_TITLE style={{ color: "white", fontWeight: 600 }}>
                    {ui.__("sidentitySettings.georgeIdBanner.title")}
                </pr.P_16_TITLE>
                <pr.P_14_CONTENT style={{ color: "white", marginTop: 6 }}>
                    {ui.__("sidentitySettings.georgeIdBanner.text")}
                </pr.P_14_CONTENT>
            </div>
        </div>
    );
};

@observer
export class SIdentitySettingsHomeScreen extends React.Component<IProps, {}> {
    @observable showConfirmDeleteDialog = false;

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    onDeleteDevice = (device: ISIdDevice) => {
        ui.isPopupVisible = true;
        this.props.store.deviceToDelete = device;
        this.showConfirmDeleteDialog = true;
    }

    onConfirmDeleteDevice = async (deleteDevice?: boolean) => {
        this.showConfirmDeleteDialog = false;
        ui.isPopupVisible = false;
        if (deleteDevice && this.props.store.deviceToDelete) {
            try {
                await this.props.store.deleteSIdSettingsDevice();
                pushRoute("/sidentitysettings/delete-signing");
            } catch (err) {
                pushRoute("/error");
            }
        }
    }

    render() {
        const authorizationType = externalInterfaceStore.settings?.authorizationType;
        const sIdentityActive = authorizationType === "SID";

        let limit = ui.__("sidentity.limit.none");
        if (this.props.store.status
            && this.props.store.status.secAppDailyLimit
            && amountToNumber(this.props.store.status.secAppDailyLimit) > 0
        ) {
            limit = amountToCurrencyString(this.props.store.status.secAppDailyLimit);
        }

        return (
            <>
                <george.Background style={{ padding: 16 }}>
                    <george.LoadingIndicator isLoading={this.props.store.isLoading()} height={ui.windowHeight} />
                    {!this.props.store.isLoading() && (
                        <>
                            {this.props.store.canActivateGeorgeId && externalInterfaceStore.isGeorgeApp && (
                                <div style={{ padding: ui.windowWidth < 800 + theme.MARGIN_SMALL * 2 ? `0 ${theme.MARGIN_SMALL}px` : undefined }}>
                                    <GeorgeIdBanner style={{ marginTop: 16, marginBottom: 40 }} />
                                </div>
                            )}
                            <MyLoginData store={this.props.store.aliasStore} />
                            {sIdentityActive && (
                                <>
                                    <SectionHeader>{ui.__("sidentitySettings.signingMethod")}</SectionHeader>
                                    <SigningMethodBanner>
                                        {sIdentityActive && <FormattedHTMLMessage id="sidentitySettings.signingMethod.sIdentity" />}
                                    </SigningMethodBanner>
                                    <MyDevices store={this.props.store} onDeleteDevice={this.onDeleteDevice} />
                                    <Settings limit={limit} limitManagementRoute="/sidentitysettings/limit" />
                                </>
                            )}
                            {!sIdentityActive && (
                                <Onboarding store={this.props.store} showCardTanInfo={authorizationType === "CARDTAN"} />
                            )}
                        </>
                    )}
                </george.Background>
                <SIdentitySettingsDeleteConfirmationDialog
                    show={this.showConfirmDeleteDialog}
                    onClose={this.onConfirmDeleteDevice}
                />
            </>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/sIdentitySettings/SIdentitySettingsHomeScreen.tsx